import { gql } from "@apollo/client";

export const GetTicketReasons = gql`
  query GetTicketReasons($token: String!, $customer_id: ID!) {
    GetTicketReasons(token: $token, customer_id: $customer_id) {
      id
      reason
      priority
      customerID
      customer {
        id
      }
    }
  }
`;

export const GetTicketReasonsByNodeId = gql`
  query GetTicketReasonsByNodeId($id: ID!, $token: String!) {
    node(id: $id, token: $token) {
      id
      ... on AtsTicketReasons {
        id
        reason
        priority
        customerID
        customer {
          id
        }
      }
    }
  }
`;
